import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AttributePanelState } from '../../../services/animation/animation.types';
import {
  _attributeState,
  containerShapeDescriptor,
  onlyShapeType,
  onlyShapeTypes,
} from '../../store/selector/editor.selector';
import { FontService } from './text/font.service';
import { setDescriptorValue } from '../../store/editor.crud.actions';
import { ContainerShapeDescriptor } from '../../../elements/resource/types/shape.type';

@Component({
  selector: 'nw-canvas-control-panel',
  templateUrl: './canvas-control-panel.component.html',
  styleUrls: ['./canvas-control-panel.component.scss'],
})
export class CanvasControlPanelComponent {
  attributeState$: Observable<AttributePanelState>;
  fillAttributeState$: Observable<AttributePanelState>;
  strokeAttributeState$: Observable<AttributePanelState>;
  onlyTextShapes$: Observable<boolean>;

  containerShapeDescriptor$: Observable<ContainerShapeDescriptor>;

  displayFilter(...shapes: string[]): Observable<boolean> {
    return this.store.select(onlyShapeTypes(shapes));
  }
  constructor(
    private readonly store: Store,
    private readonly fontService: FontService,
  ) {
    this.attributeState$ = this.store.select(_attributeState('textConfig'));
    this.onlyTextShapes$ = this.store.select(onlyShapeType('text-shape'));

    this.fillAttributeState$ = this.store.select(_attributeState('fill'));
    this.strokeAttributeState$ = this.store.select(_attributeState('stroke'));

    this.containerShapeDescriptor$ = this.store.select(
      containerShapeDescriptor,
    );

    this.containerShapeDescriptor$.subscribe(val => {
      // -- // -- // -- // -- //
      // console.log('containerShapeDescriptor', val);
    });

    this.attributeState$.subscribe(val => {
      // -- // -- // -- // -- //
    });
  }

  flipTopology(topology: ContainerShapeDescriptor['topology']) {
    // -- //
    this.store.dispatch(
      setDescriptorValue({
        key: 'topology',
        value: topology == 'row' ? 'column' : 'row',
        direct: true,
      }),
    );
  }

  showFontWeightSelector(fontFamily: string) {
    // -- // -- //
    const descriptor = this.fontService.descriptors[fontFamily];
    if (!descriptor) {
      return;
    }

    if (descriptor.fonts.length > 1) {
      return descriptor.fonts.find(({ style }) => style !== 'normal');
    }
  }
}
